import React, {
  useContext,
  useState,
  Fragment,
  useRef,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormControl, FormLabel, Input, Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";
import "./styles/Settings.css";
import { DropDownTreeComponent } from "@syncfusion/ej2-react-dropdowns";
import { TreeViewComponent } from "@syncfusion/ej2-react-navigations";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function SettingsRequirements(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const [categoryTree, setCategoryTree] = useState([]);
  const newCategoryName = useRef("");
  const changedNodes = useRef([]);
  const executeSave = useRef(false);
  const [wait, setWait] = useState(false);
  const [pageContent, setPageContent] = useState(
    <Typography fontSize="x-large" className="settingsGroupTitle">
      Loading...
    </Typography>,
  );

  let categoryDropdown;
  const treeView = useRef();
  const nodesArray = useRef([]);
  const prefRecId = useRef();

  if (treeView.current) {
    treeView.current.expandAll();
  }

  const handleTextFieldChange = (event) => {
    newCategoryName.current = event.target.value;
  };

  const handleAddClick = () => {
    if (treeView.current) {
      treeView.current.expandAll();
    }
    const newTree = JSON.parse(JSON.stringify(categoryTree));

    /*if (
      categoryDropdown.value &&
      categoryDropdown.value.length > 0 &&
      categoryDropdown.value[0] != "00"
    ) {
      const idSegmentArray =
        categoryDropdown.value[0].indexOf("-") >= 0
          ? categoryDropdown.value[0].split("-")
          : categoryDropdown.value;
      let fullId = "";
      let tempTree = newTree;
      for (let i = 0; i < idSegmentArray.length; i++) {
        const parentIndex = tempTree.findIndex(
          (elem) => elem.nodeId == fullId + idSegmentArray[i],
        );

        fullId += idSegmentArray[i] + "-";
        tempTree = tempTree[parentIndex].nodeChild;
      }

      const newSubId =
        tempTree.length + 1 < 10
          ? "0" + (tempTree.length + 1)
          : tempTree.length + 1;
      tempTree.push({
        nodeText: newCategoryName.current,
        nodeId: fullId + newSubId,
        nodeChild: [],
        expanded: true,
      });
      nodesArray.current.push(fullId + newSubId);
    } else {*/
    const newId =
      categoryTree.length + 1 < 10
        ? "0" + (categoryTree.length + 1)
        : categoryTree.length + 1;
    newTree.push({
      nodeText: newCategoryName.current,
      nodeId: newId,
      nodeChild: [],
      expanded: true,
    });
    nodesArray.current.push(newId);
    //}

    executeSave.current = true;
    setCategoryTree(newTree);
  };

  useEffect(() => {
    if (executeSave.current) {
      executeSave.current = false;

      setWait(true);
      sessionStorage.setItem(
        "reqCategories" + projectObject.id,
        JSON.stringify(categoryTree),
      );
      let sendString = authString;
      if (prefRecId.current) {
        //categoryTree.shift();
        console.log(prefRecId.current);
        sendString +=
          '<Modify type="Preference"><Preference><id>' +
          prefRecId.current +
          "</id><setting>" +
          JSON.stringify(categoryTree) +
          "</setting></Preference></Modify>";
      } else {
        sendString +=
          '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><name>reqCategories' +
          projectObject.id +
          "</name><setting>" +
          JSON.stringify(categoryTree) +
          "</setting></Preference></Add>";
      }
      sendString += "</request>";

      processReqsWithDeletedCategories();

      //updateReqs.then(() => {
      Tools.fetchPost(sendString, urlString).then(() => {
        setWait(false);
        //props.handleSettingsChange(null, "Requirements");
      });
      //});
      //props.handleSettingsChange(null, "Requirements");
    }
  }, [categoryTree]);

  function processReqsWithDeletedCategories() {
    for (let k = 0; k < changedNodes.current.length; k++) {
      if (changedNodes.current[k].newText == "") {
        const readString =
          authString +
          '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><oada_req_category__c>' +
          changedNodes.current[k].nodeId +
          "</oada_req_category__c></Issue></Read></request>";
        Tools.fetchPost(readString, urlString, "Issue").then((rawIssueRecs) => {
          let issueModString = authString;
          if (rawIssueRecs.xml.length > 0) {
            const issueRecs = Tools.xmlToArray(rawIssueRecs.xml);
            issueRecs.forEach((elem) => {
              issueModString +=
                '<Modify type="Issue" enable_custom="1"><Issue><id>' +
                elem.id +
                "</id><oada_req_category__c></oada_req_category__c></Issue></Modify>";
            });

            issueModString += "</request>";
            Tools.fetchPost(issueModString, urlString);
          }
        });
      }
    }
  }

  // may not be necessary
  /*const updateReqs = new Promise((resolve) => {
    for (let j = 0; j < changedNodes.current.length; j++) {
      const readString =
        authString +
        '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><oada_req_category__c>' +
        changedNodes.current[j].nodeId +
        "</oada_req_category__c></Issue></Read></request>";
      Tools.fetchPost(readString, urlString, "Issue").then((rawIssueRecs) => {
        let issueModString = authString;
        if (rawIssueRecs.xml.length > 0) {
          const issueRecs = Tools.xmlToArray(rawIssueRecs.xml);
          issueRecs.forEach((elem) => {
            issueModString +=
              '<Modify type="Issue" enable_custom="1"><Issue><id>' +
              elem.id +
              "</id><oada_req_category__c>" +
              changedNodes.current[j].nodeId +
              "</oada_req_category__c></Issue></Modify>";
          });

          issueModString += "</request>";
          Tools.fetchPost(issueModString, urlString).then(() => {
            if (j == changedNodes.current.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  });
*/
  useEffect(() => {
    setWait(true);
    let initialTree = [];
    const requestString =
      authString +
      '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>reqCategories' +
      projectObject.id +
      "</name></Preference></Read></request>";

    Tools.fetchPost(requestString, urlString, "Preference").then(
      (prefRecXML) => {
        if (prefRecXML.xml.length > 0) {
          const prefRec = Tools.xmlToArray(prefRecXML.xml);
          initialTree = JSON.parse(prefRec[0].setting);
          prefRecId.current = prefRec[0].id;
        }
        setCategoryTree(initialTree);
        setWait(false);
      },
    );
  }, []);

  const handleNodeEdit = (event) => {
    if (event.name == "nodeEdited") {
      replaceNodeName(categoryTree, event.nodeData.id, event.newText);
      changedNodes.current.push({
        nodeId: event.nodeData.id,
        parentId: event.nodeData.parentID,
        oldText: event.oldText,
        newText: event.newText,
      });
    }
  };

  const handleNodeRealignment = (event) => {
    //draggedNodeData, droppedNodeData, position="After", dropTarget will be null if moved to first tier
    /*changeNodePosition(
      categoryTree,
      event.draggedNodeData.id,
      event.droppedNodeData.id,
      event.dropTarget,
    );*/
    executeSave.current = true;
    setCategoryTree(treeView.current.treeData);
    console.log(treeView.current);
  };

  function changeNodePosition(nodeArray, id, newParentId, dropTarget) {
    for (let i = 0; i < nodeArray.length; i++) {
      if (nodeArray[i].nodeId == id) {
        const removedElement = nodeArray.splice(i, 1);
        for (let j = 0; j < nodeArray.length; j++) {
          if (nodeArray[j].nodeId == newParentId) {
            //removedElement.parentId = newParentId;
            nodeArray[j].nodeChild.push(removedElement[0]);
          }
        }
      } else {
        if (nodeArray[i].nodeChild.length > 0) {
          changeNodePosition(nodeArray[i].nodeChild, id, newParentId);
        }
      }
    }
  }

  function replaceNodeName(nodeArray, id, newName) {
    for (let i = 0; i < nodeArray.length; i++) {
      if (nodeArray[i].nodeId == id) {
        if (newName == "") {
          nodeArray.splice(i, 1);
        } else {
          nodeArray[i].nodeText = newName;
        }
      } else {
        if (nodeArray[i].nodeChild.length > 0) {
          replaceNodeName(nodeArray[i].nodeChild, id, newName);
        }
      }
    }
  }

  const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      handleAddClick();
    }
  };

  useEffect(() => {
    const categoryDropdownFields = {
      dataSource: categoryTree,
      value: "nodeId",
      text: "nodeText",
      child: "nodeChild",
    };
    const treeFields = {
      dataSource: categoryTree,
      id: "nodeId",
      text: "nodeText",
      child: "nodeChild",
    };

    const initialContent = (
      <Box>
        <Box>
          <span className="settingsGroupTitle">
            Requirement Categories for Project:
          </span>
          <span
            className="settingsGroupTitle"
            style={{
              textTransform: "uppercase",
              color: "lightblue",
              fontWeight: "bold",
            }}
          >
            &nbsp;
            {projectObject.name}
          </span>
        </Box>
        <Box
          sx={{
            backgroundColor: "white",
            maxHeight: "80vh",
            overflow: "auto",
            border: "5px solid",
            borderColor: "#643f69",
            marginTop: "10px",
          }}
        >
          <Input
            className="settingsTextField"
            onChange={handleTextFieldChange}
            onKeyDown={handleKeyPress}
            placeholder="Add category, then hit Enter..."
            sx={{
              height: "30px",
              border: "none",
              padding: "0px",
              width: "400px",
            }}
          ></Input>
          {categoryTree.length > 0 ? (
            <TreeViewComponent
              allowEditing={true}
              allowDragAndDrop={true}
              cssClass="settingsTreeElement"
              fields={treeFields}
              ref={(tv) => (treeView.current = tv)}
              //expandedNodes={nodesArray.current}
              loadOnDemand={false}
              nodeEdited={handleNodeEdit}
              nodeDropped={handleNodeRealignment}
            />
          ) : (
            <Typography sx={{ textAlign: "center", padding: "5px" }}>
              &nbsp;
            </Typography>
          )}
        </Box>
        <Typography
          sx={{
            paddingTop: "10px",
            fontStyle: "italic",
            fontSize: "12px",
            color: "white",
          }}
        >
          Double-clicking a category allows the name to be edited
        </Typography>
        <Typography
          sx={{
            paddingTop: "10px",
            fontStyle: "italic",
            fontSize: "12px",
            color: "white",
          }}
        >
          A category can be dragged and dropped in between other categories to
          change the order.
        </Typography>
        <Typography
          sx={{
            paddingTop: "10px",
            fontStyle: "italic",
            fontSize: "12px",
            color: "white",
          }}
        >
          A category can be dragged and dropped on top of another category to
          make it a child of that category
        </Typography>
      </Box>
    );

    setPageContent(initialContent);
  }, [categoryTree]);

  return (
    <Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait}
        //onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {pageContent}
    </Fragment>
  );
}

export default SettingsRequirements;

SettingsRequirements.propTypes = {
  handleSettingsChange: PropTypes.func,
};

/*
                <Box sx={{ textAlign: "center" }}>
                  <Button
                    className="settingsButtonActiveDialog"
                    onClick={handleSaveClick}
                    sx={{ width: "150px" }}
                  >
                    Save Categories
                  </Button>
                </Box>
                */
